import NavbarComponent from "@/components/Navbar"
import clsx from "clsx"
import { useGlobalContext } from "@/global/GlobalContext"
import { menu } from "@/app/utils/constants"
import NavBorder from "@/assets/imgs/our-story/nav-border.png"
import NavBgBorder from "@/assets/imgs/our-story/nav-bg-border.webp"
import NavBorderSeparator from "@/assets/imgs/our-story/nav-border-separator.png"
import { Link } from "react-router-dom"
import { useEffect, useRef, useState } from "react"
import SEO from "@/components/SEO"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import PlateDisplay from "@/assets/imgs/di-sana/porcelain-catalog/plate-display-1.webp"
import PlateDisplay450 from "@/assets/imgs/di-sana/porcelain-catalog/plate-display-1-450.webp"
import PlateDisplay600 from "@/assets/imgs/di-sana/porcelain-catalog/plate-display-1-600.webp"
import PlateDisplay800 from "@/assets/imgs/di-sana/porcelain-catalog/plate-display-1-800.webp"
import Monkey2 from "@/assets/imgs/di-sana/porcelain-catalog/monkey-2.webp"
import Monkey2300 from "@/assets/imgs/di-sana/porcelain-catalog/monkey-2-300.webp"
import Penjor1 from "@/assets/imgs/di-sana/porcelain-catalog/penjor1.webp"
import Penjor2 from "@/assets/imgs/di-sana/porcelain-catalog/penjor2.webp"
import MainLogo from "@/components/MainLogo"

const GeneralLayout = ({ children, bgColor = "", isFixed = true, hasGreekL = true, contentColor = "text-charcoal-black", relativeCls = "", heroTitle, pageTitle }) => {
  const { pathname, setLoading, setIsShowBG, setOpenGapura, isToggled, setIsToggled, setIsPlaying, finishToggled, seoContent } = useGlobalContext()
  const ourStoryDetails = menu[0].details
  const [allLoaded, setAllLoaded] = useState(false)
  const [loadedImgs, setLoadedImgs] = useState(0)
  const isMounted = useRef(false);
  const [withMainLogo, setWithMainLogo] = useState(true)

  useEffect(() => {
    return () => {
      isMounted.current = true;
    };
  }, []);

  useEffect(() => {
    if (loadedImgs == ourStoryDetails.length) {
      const timer = setTimeout(() => {
        setAllLoaded(true)
      }, 200)

      return () => clearTimeout(timer)
    }
  }, [loadedImgs])

  useEffect(() => {
    setWithMainLogo(!pathname.includes("loro-blonyo-fine-porcelain"))
  }, [pathname])

  const onClickLogo = () => {
    setLoading("exit")
    setIsShowBG(true)
    setOpenGapura(true)
    setIsToggled(false)
    setIsPlaying(false)
  }

  const handleImageLoad = () => {
    if (isMounted.current) return;
    setLoadedImgs((prev) => typeof prev === "number" ? prev + 1 : 1)
  }

  return (
    <>
      <SEO post={seoContent} />
      <NavbarComponent bgColor={bgColor} hasGreekL={hasGreekL} contentColor={contentColor} />
      {/* "fixed": isFixed,  */}
      {withMainLogo ?
        <div className={clsx("text-center pt-0.5 xs:pt-1 2xl:pt-2 left-0 h-[18vh] mt-14 sm:mt-16 flex flex-col", { "z-50": !!relativeCls && !isToggled && finishToggled, "z-10": !relativeCls || isToggled, "absolute": isFixed, "max-sm:hidden": pathname.includes("dashboard"), "left-1/2 -translate-x-1/2": !hasGreekL, "w-full": hasGreekL }, bgColor)}>
          <Link to="/" onClick={onClickLogo} className={clsx("option-logo my-auto", { "mx-auto": hasGreekL }, relativeCls)}>
            {(contentColor == "text-white") ? (
              <MainLogo isWhite />
            ) : (
              <MainLogo />
            )}
          </Link>
          {/* Our Story submenu pills */}
          {pathname.indexOf("our-story") > -1 && (
            <>
              <div className="w-full max-lg:px-1 lg:w-[950px] lg:min-w-[950px] lg:max-w-[1150px] h-full mx-auto flex items-end mb-0.5">
                <div className="flex justify-between w-full">
                  <ul className={clsx("flex w-[45%] lg:w-[30%] 2xl:w-1/4 relative", { "gap-1 h-6 sm:h-8": !allLoaded })}>
                    {allLoaded &&
                      <img width="40" src={NavBorderSeparator} className="absolute top-0 left-1/2 -translate-x-1/2 w-[24px] sm:w-[44px] lg:w-[42px]" alt="" />
                    }
                    {ourStoryDetails.map((d, i) => (
                      i < 2 && (
                        <li key={i} className={clsx({ "w-full animate-shimmer transition-opacity bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200": !allLoaded })}>
                          <div className={clsx("flex justify-center items-center px-1 pt-[1px] lg:pt-0.5 relative", { "hidden": !allLoaded })}>
                            <img width="100" src={NavBorder} onLoad={handleImageLoad} className="w-full" alt="" />
                            {pathname == d.link && (
                              <img width="100" src={NavBgBorder} className="w-full absolute" alt="" />
                            )}
                            <Link to={d.link} className="absolute max-lg:top-[5px] text-[10px] sm:text-xl font-agcasmlt font-extralight tracking-wide text-charcoal-black">{d.name}</Link>
                          </div>
                        </li>
                      )
                    ))}
                  </ul>
                  <ul className={clsx("flex w-[45%] lg:w-[30%] 2xl:w-1/4 relative", { "gap-1 h-6 sm:h-8": !allLoaded })}>
                    {allLoaded &&
                      <img width="40" src={NavBorderSeparator} className="absolute top-0 left-1/2 -translate-x-1/2 w-[24px] sm:w-[44px] lg:w-[42px]" alt="" />
                    }
                    {ourStoryDetails.map((d, i) => (
                      i >= 2 && (
                        <li key={i} className={clsx({ "w-full animate-shimmer transition-opacity bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200": !allLoaded })}>
                          <div className={clsx("flex justify-center items-center px-1 pt-[1px] lg:pt-0.5 relative", { "hidden": !allLoaded })}>
                            <img width="100" src={NavBorder} onLoad={handleImageLoad} className="w-full" alt="" />
                            {pathname == d.link && (
                              <img width="100" src={NavBgBorder} className="w-full absolute" alt="" />
                            )}
                            <Link to={d.link} className="absolute max-lg:top-[5px] text-[10px] sm:text-xl font-agcasmlt font-extralight tracking-wide text-charcoal-black">{d.name}</Link>
                          </div>
                        </li>
                      )
                    ))}
                  </ul>
                </div>
              </div>
            </>
          )}
        </div>
        :
        <section className="relative overflow-x-hidden bg-[url('/src/assets/imgs/di-sana/porcelain-catalog/background-blue1.webp')] bg-cover bg-bottom">
          {/* for porcelain catalog */}
          <div className="relative text-center w-full pt-0.5 xs:pt-1 2xl:pt-2 left-0 h-[18vh] mt-14 sm:mt-16 mb-7 sm:mb-8 flex flex-col">
            <Link to="/" onClick={onClickLogo} className="option-logo my-auto mx-auto">
              <MainLogo />
            </Link>
          </div>
          {/* start with those bunch of images */}
          <div className="relative w-full h-[300px] 2sm:h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[900px] 2xl:h-[1400px]">
            <div className="relative left-1/2 -translate-x-1/2">
              <h1 className="font-sloopScriptPro text-2xl sm:text-4xl md:text-5xl lg:text-6xl 2xl:text-7xl font-light text-[#95702e] text-center mb-10">
                {heroTitle}
                <span className="block">{pageTitle}</span></h1>
            </div>
            {/* stack of images */}
            <div className="w-[85%] sm:w-4/5 relative sm:top-5 lg:top-0 xl:top-20 2xl:top-[300px] left-1/2 -translate-x-1/2">
              <ImageSkeleton loading="eager" isDiffSkeletonSize src={Monkey2300} srcSet={`${Monkey2300} 300w, ${Monkey2} 600w`} sizes="100vw" custCls="w-full h-[210px] 2sm:h-[300px] sm:h-[350px] md:h-[400px] lg:h-[530px] xl:h-[700px] 2xl:h-[900px] object-cover object-bottom" custStyle="h-[210px] 2sm:h-[300px] sm:h-[350px] md:h-[400px] lg:h-[530px] xl:h-[700px] 2xl:h-[900px]" alt="Monkey and Penjor" />
            </div>
            <div className="w-4/5 md:w-[75%] lg:w-[70%] absolute z-10 -left-[15%] -bottom-8 xs:top-0">
              <ImageSkeleton noShimmer src={Penjor2} custCls="w-full h-full object-cover" alt="Left penjor" />
            </div>
            <div className="w-4/5 md:w-[75%] lg:w-[70%] absolute z-10 -right-[15%] -bottom-8 xs:top-0">
              <ImageSkeleton noShimmer src={Penjor1} custCls="w-full h-full object-cover" alt="Right penjor" />
            </div>
          </div>
          <div className="w-full xl:w-[90%] mx-auto relative -mt-14 2sm:-mt-[20%] md:-mt-[25%] lg:-mt-[17%] 2xl:-mt-[18%] z-20">
            <ImageSkeleton src={PlateDisplay450} srcSet={`${PlateDisplay450} 450w, ${PlateDisplay600} 600w, ${PlateDisplay800} 800w, ${PlateDisplay} 1200w`} sizes="100vw" custCls="w-full object-cover" custStyle="h-[250px] 2sm:h-[300px] md:h-[400px] lg:h-[700px] xl:h-[800px]" alt="Porcelain Catalog Display" />
          </div>
        </section>
      }
      {children}
    </>
  )
}

export default GeneralLayout
